// extracted by mini-css-extract-plugin
export default {"img":"GiftRepeatableContent_img__mxzWF","imgContainer":"GiftRepeatableContent_imgContainer__ZlDO+","repeatableContentText":"GiftRepeatableContent_repeatableContentText__nUQNa"};